module.exports = __webpack_public_path__ + "static/media/kerrygold.b9c1459c.png";